import { HubletOption } from 'signup-constants/signupData/HubletOption';
import { AppKey } from '../../app/AppKey';
import { AppActionTypes } from './action-types';
export const initialAppState = {
  [AppKey.AcademyContentPageName]: null,
  [AppKey.Hublet]: HubletOption.na1,
  [AppKey.VerificationType]: null,
  [AppKey.IsNewPortalCreated]: false,
  [AppKey.IsNewUser]: false,
  [AppKey.CompleteVerificationComplete]: false,
  [AppKey.HasRefreshedNewPortalAuth]: false,
  [AppKey.Country]: null,
  [AppKey.IsUsingOptionalDomain]: false,
  [AppKey.IsOAuthExistingUser]: false,
  [AppKey.IsExistingUserSession]: false,
  [AppKey.RedirectUrl]: '',
  [AppKey.FirstOAuthPartnerClick]: '',
  [AppKey.IsVerifiedByGoogleCredential]: false,
  [AppKey.WhichOAuthEndpointFailed]: null
};

const appReducer = (state = initialAppState, action) => {
  switch (action.type) {
    case AppActionTypes.UpdateKeyValue:
      return Object.assign({}, state, {
        [action.key]: action.value
      });

    default:
      return state;
  }
};

export default appReducer;